export const grades = [
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
  "XI",
  "XII"
]

export const examTypes = [
  "Pre Boards",
  "Class Test",
  "Full Mock Test",
  "Test Series",
  "Mock Master",
];
export const subjects = [
  "Science",
  "Math",
  "English",
  "Hindi",
  "Social Studies",
  "Accounting",
  "Business Law",
  "Quantitative Aptitude",

  "Business Economics",
  "गृह विज्ञान",
  "चित्रकला",
  "योग",
  "व्यवसाय अध्ययन",
  "संस्कृति एवं विरासत",
  "सामाजिक विज्ञान",
  "डाटा एंट्री",

  "राजस्थानी",
  "हिंदी",
  "अर्थशास्त्र",
  "उद्यमिता",
  "भारतीय विरासत",
  "Statistics",
  "Economics",
  "Business Studies"
];